import { PlanningDay, PlanningScope, PlanningType } from "@eisox/api/core-api";
import { z } from "@eisox/zod";

export const updateRoomsPlanningsSchema = z.object({
  scope: z.enum(PlanningScope),
  parentIds: z.array(z.string().nonempty()).min(1),
  plannings: z.array(
    z.object({
      day: z.enum(PlanningDay),
      hourStart: z.string(),
      hourEnd: z.string(),
      type: z.enum(PlanningType),
      userDefined: z.boolean(),
    }),
  ),
});

export type UpdateRoomsPlanningsSchemaType = z.infer<typeof updateRoomsPlanningsSchema>;
